if (window.AFB_MOBILE_MENU_V6) { /* legacy mobile_menu.js disabled */ }
else {
$(document).ready(function () {

  // adiciona o botão de abrir/fechar nos itens que têm filho
  $("#ma-mobilemenu .had_child, ul.mobilemenu li span.button-view1, ul.mobilemenu li span.button-view2").each(function () {
    $(this).append('<span class="ttclose ttnavigation"><a href="javascript:void(0)"></a></span>');
  });

  // mantém submenus abertos para itens já ativos
  $("ul.mobilemenu li.active").each(function () {
    $(this).children().next("ul").css('display', 'block');
  });

  // esconde todos os submenus por padrão
  $("ul.mobilemenu li ul").hide();

  // ===== NÍVEL 2 – botão-view1 =====
  $('span.button-view1 span').on('click', function () {
    var varche = $(this).hasClass('ttopen');

    if (!varche) {
      $(this).addClass("ttopen").removeClass("ttclose");
      $(this).parent().parent().find('ul.level2').slideDown();
    } else {
      $(this).removeClass("ttopen").addClass("ttclose");
      $(this).parent().parent().find('ul.level2').slideUp();
    }
  });

  // ===== NÍVEL 3 – botão-view2 =====
  $('span.button-view2 span').on('click', function () {
    var varche = $(this).hasClass('ttopen');

    if (!varche) {
      $(this).addClass("ttopen").removeClass("ttclose");
      $(this).parent().parent().find('ul.level3').slideDown();
    } else {
      $(this).removeClass("ttopen").addClass("ttclose");
      $(this).parent().parent().find('ul.level3').slideUp();
    }
  });

  // ===== MENU ORIGINAL (desktop) =====
  $('.originalmenu span.ttnavigation').on('click', function () {
    var varche = $(this).hasClass('ttopen');

    if (!varche) {
      $(this).addClass("ttopen").removeClass("ttclose");
      $(this).parent().children('ul').slideDown();
    } else {
      $(this).removeClass("ttopen").addClass("ttclose");
      $(this).parent().children('ul').slideUp();
    }
  });

  // ===== MOBILE – abre/fecha drawer lateral =====
  $('.btn-navbar').on('click', function () {
    var $nav = $('#navbar-inner');
    var isInactive = $nav.hasClass('navbar-inactive');

    if (isInactive) {
      // ABRIR
      $nav.removeClass('navbar-inactive').addClass('navbar-active');
      $('body').addClass('afb-menu-open');

      // garante que o menu está visível (display:block)
      $('#ma-mobilemenu').stop(true, true).slideDown(0);
    } else {
      // FECHAR
      $nav.removeClass('navbar-active').addClass('navbar-inactive');
      $('body').removeClass('afb-menu-open');

      $('#ma-mobilemenu').stop(true, true).slideUp(0);
    }
  });

}); // <- fecha o document.ready

}
